import { Base } from '../../abstract/base.model';
import { isRecord } from '../utils/is-record';
import { nullableNumber, nullableString } from '../utils/wire-value-utils';

/**
 * A drone manufacturer in the catalog, built from the hub's `/admin/drone-manufacturers` JSON
 * (hub `data-models/drone-manufacturer.ts`). Writable fields the hub didn't send stay `undefined`
 * (an explicit `null` stays `null`). The hub's `isSeeded` flag is not mapped.
 */
export class DroneManufacturer extends Base {
  // Writable via PUT /admin/drone-manufacturers/:id (the hub's DRONE_MANUFACTURER_WRITABLE)
  name?: string | null;
  description?: string | null;
  url?: string | null;
  logoUrl?: string | null;

  /** Read-only: set only when the hub joins the model count. */
  modelCount?: number | null;

  constructor(data: unknown) {
    super(data);
    const source = isRecord(data) ? data : {};
    this.name = nullableString(source['name']);
    this.description = nullableString(source['description']);
    this.url = nullableString(source['url']);
    this.logoUrl = nullableString(source['logoUrl']);
    this.modelCount = nullableNumber(source['modelCount']);
  }
}
